import Modal from './Modal';
import alert from './alert';
import prompt from './prompt';
import operation from './operation';
Modal.alert = alert;
Modal.prompt = prompt;
Modal.operation = operation;
export default Modal;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd-mobile/es/modal/index.js
// module id = 366
// module chunks = 0